<template>
  <a
    class="ti-next-best-action"
    :href="url"
    :target="targetBlank === true ? '_blank' : '_self'"
    @click="onClicked()"
  >
    <div class="ti-next-best-action__content">
      <div class="ti-next-best-action__image" v-if="image">
        <wb-aspect-ratio ratio="3x2">
          <img :src="image" />
        </wb-aspect-ratio>
      </div>
      <div class="ti-next-best-action__text">
        <h3 class="ti-next-best-action__label">
          {{ description }}
        </h3>

        <p class="ti-next-best-action__description">
          <wb-icon
            v-if="label"
            class="ti-next-best-action__arrow"
            name="bds/chevron-right/24"
          ></wb-icon>
          {{ label }}
        </p>
        <div class="ti-next-best-action__overlay"></div>
      </div>
    </div>
  </a>
</template>
<script lang="ts" setup>
interface Props {
  label?: string;
  description?: string;
  url?: string;
  targetBlank?: boolean;
  image?: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['clicked']);

const onClicked = (): void => {
  emit('clicked');
};
</script>
<style lang="scss" src="./next-best-action.scss"></style>
